import styles from "./index.module.less";

export default function AuthSubjectInfo() {
  return (
    <div className={styles.info}>
      <div className={styles.title}>商用授权须知</div>
      <ul className={styles.desc}>
        <li>
          1、您成为花瓣素材会员后，花瓣素材在您每次下载正版素材时为您提供本次下载内容的商业授权书；
        </li>
        <li>
          2、您的会员权限在会员订单有效期内仅对您填写的被授权方有效，被授权方仅能为限单一主体（单个企业或个人），禁止共享或转让！
        </li>
        <li>
          3、以下被授权方信息在会员订单有效期内只能填写1次，填写后，您在会员订单有效期内下载的正版素材商业授权书上的被授权方均默认为以下被授权方；如您另行加购商用授权主体，则可在每次下载前从已确认的授权主体中选择被授权方
        </li>
        <li>
          4、请您根据下方提示填写被授权方信息，被授权方信息及授权书一经提交下载，将无法更改；
        </li>
        <li>5、公司名称、单位代码为公开信息，可在“天眼查”等平台查看；</li>
        <li>6、我们会严格保护您的隐私，请您放心填写。</li>
      </ul>
    </div>
  );
}
